import React from 'react';

import styled from 'styled-components';

import { Button, View, colors } from '@fairygodboss/ui';

import OldButton from '../../Input/Button/Button';

const openEvent = (url) => {
    const newTab = window.open(url, '_blank');
    newTab.focus();
};

const MobileButtonWrap = styled(View)`
    width: 100%;

    .component-CallToAction-AuthWrapperComponent {
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
    }

    .component-CallToAction-AuthWrapperComponent > .wrap-auth-div {
        align-self: stretch;
        width: auto;
    }

    .component-CallToAction-AuthWrapperComponent > .wrap-auth-div button {
        width: 100%;
    }
`;

export const AttendingButton = ({
    isSingleEventPage,
    url,
    isLiveEvent,
    isStartingSoon = false,
}) => (
    <>
        {url ? (
            <>
                <MobileButtonWrap
                    display={{ _: 'flex', sm: 'none' }}
                    css={{
                        button: {
                            backgroundColor: colors.primary[60],
                            borderColor: 'transparent',
                            ':hover': {
                                backgroundColor: '#a234b2',
                                outline: 'none',
                            },
                            ':focus': {
                                backgroundColor: '#a234b2',
                                outline: 'none',
                            },
                            marginRight: '0px',
                            color: '#ffffff',
                            outline: 'none',
                            borderStyle: 'none',
                            borderRadius: '4px',
                            fontWeight: 600,
                        },
                        span: { overflow: 'visible' },
                    }}
                    fontFamily="Open Sans, sans-serif"
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="18px"
                >
                    {isSingleEventPage ? (
                        <Button
                            data-qa="Join-event-button"
                            size="medium"
                            mr="4px"
                            minHeight="40px"
                            width="180px"
                            variant="primaryText"
                            onPress={() => openEvent(url)}
                        >
                            {isSingleEventPage ? 'Join event' : 'Attending'}
                        </Button>
                    ) : (
                        <span className="text text-generic">Attending</span>
                    )}
                </MobileButtonWrap>
                <View
                    display={{ _: 'none', sm: 'flex' }}
                    css={{
                        button: {
                            backgroundColor: colors.primary[60],
                            borderColor: 'transparent',
                            ':hover': {
                                backgroundColor: '#a234b2',
                                outline: 'none',
                            },
                            ':focus': {
                                backgroundColor: '#a234b2',
                                outline: 'none',
                            },
                            color: '#ffffff',
                            outline: 'none',
                            marginRight: '0px',
                            borderStyle: 'none',
                            borderRadius: '4px',
                            fontWeight: 600,
                        },
                        span: { overflow: 'visible' },
                    }}
                    fontFamily="Open Sans, sans-serif"
                    fontSize="14px"
                    lineHeight="18px"
                >
                    {isSingleEventPage && !isLiveEvent ? (
                        <Button
                            data-qa="Join-event-button"
                            size="medium"
                            mr="16px"
                            minWidth="180px"
                            minHeight="40px"
                            variant="primary"
                            onPress={() => openEvent(url)}
                        >
                            {isSingleEventPage ? 'Join event' : 'Attending'}
                        </Button>
                    ) : null}
                    {(isStartingSoon || isLiveEvent) && !isSingleEventPage ? (
                        <OldButton
                            data-qa="Join-event-button"
                            type="solid"
                            class="default-btn"
                            inputStyle="btn-input"
                            value="Join live event"
                            onClick={() => openEvent(url)}
                        />
                    ) : null}
                    {!isStartingSoon && !isLiveEvent && !isSingleEventPage ? (
                        <span className="text text-generic">Attending</span>
                    ) : null}
                </View>
            </>
        ) : (
            <span className="text text-generic">You have registered</span>
        )}
    </>
);
